import { Stack, Typography } from '@mui/material'
import NumberFlow from '@number-flow/react'

type Props = {
  value: number
  className?: string
}

export const RentDisplay = ({ value, className = '' }: Props) => {
  const getTextSize = (value: number) => {
    const valueString = value.toString()
    const length = valueString.length

    if (length <= 3) return 'text-8xl'
    return 'text-7xl'
  }

  return (
    <Stack className={`w-full p-4 mt-8 bg-[#FBE507] rounded-4d ${className}`}>
      <Stack
        className="items-center gap-2.5 py-6 border rounded-4d"
        style={{
          border: '1px solid transparent',
          background:
            'linear-gradient(#fdefa8, #FBE507) padding-box, linear-gradient(0deg, #FBE507 0%, #FBE507 0%, #fff 70%, #fff 100%) border-box',
        }}>
        <Typography className="text-base font-semibold text-zBlack200">
          Váš druhý mesačný dôchodok
        </Typography>
        <Stack className="h-24 justify-center">
          <Typography
            className={`${getTextSize(value)} font-black text-zBlack200 text-nowrap break-all tabular-nums`}
            style={{ wordBreak: 'break-all' }}>
            <NumberFlow value={value} suffix="€" />
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}
